// extracted by mini-css-extract-plugin
module.exports = {"svgRoot":"_3Lcs9","svgButton":"Ax1TF"};